function Welcome() {
  return (
    <div>
      <h1 style={{ margin: "0 auto", color: "blue" }}>Welcome to Home Page</h1>
    </div>
  );
}

export default Welcome;
